import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption, UserRole, UserRolesAdapted } from '@fleet-beat/core';

@Pipe({
  name: 'userRoleAdaptedPipe',
})
export class UserRoleAdaptedPipe implements PipeTransform {
  transform(value: UserRole): string | null {
    if (!value) return null;
    return UserRolesAdapted.find((role: SelectOption) => role.value === value).label;
  }
}
